const split_pay_close = document.querySelector('#split-pay-close');
const split_pay_modal_outer = document.querySelector('#split-pay-modal-outer');
const split_pay_elements = document.querySelector("#split-pay-elements");
const split_pay_modal_body_id = document.querySelector('#split-pay-modal-body-id');
let currentUserPos;

if (split_pay_modal_outer) {
    document.addEventListener("scroll", () => {
        currentUserPos = window.scrollY;
        // split_pay_modal_outer.style.paddingTop = `${currentUserPos}px`;
    });
    split_pay_modal_outer.addEventListener('click', () => {
        if (split_pay_modal_outer && split_pay_modal_body_id) {
            split_pay_modal_outer.classList.remove('open');
            split_pay_modal_body_id.classList.remove('isOpenNoScroll');
        }
    });
}

if (split_pay_elements) {
    split_pay_elements.addEventListener('click', () => {
        if (split_pay_modal_outer && split_pay_modal_body_id) {
            split_pay_modal_outer.classList.add('open');
            split_pay_modal_body_id.classList.add('isOpenNoScroll');
        }
    });
}


if (split_pay_close) {
    split_pay_close.addEventListener('click', () => {
        if (split_pay_modal_outer && split_pay_modal_body_id) {
            split_pay_modal_outer.classList.remove('open');
            split_pay_modal_body_id.classList.remove('isOpenNoScroll');
        }
    });
}
